import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex flex-col px-4 text-2xl font-light border-b border-gray-200 dark:border-gray-600" };
const _hoisted_2 = {
    key: 0,
    class: "flex pb-6 pr-12 text-gray-500 dark:text-gray-300"
};
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    ...componentI18n('views.teams.show.sidebar')
};
import SvgIcon from '@/components/SvgIcon.vue';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'Toggable',
    props: {
        open: { type: Boolean },
        title: null
    },
    emits: ['toggle'],
    setup(__props, { emit }) {
        function toggleToggable() {
            emit('toggle');
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("button", { onClick: toggleToggable }, [
                    _createElementVNode("div", {
                        class: _normalizeClass(["flex items-center justify-between pt-10 space-x-8 text-left text-primary-1000 dark:text-gray-300", __props.open ? 'pb-4' : 'pb-10'])
                    }, [
                        _createElementVNode("div", null, _toDisplayString(__props.title), 1),
                        (!__props.open)
                            ? (_openBlock(), _createBlock(SvgIcon, {
                                key: 0,
                                class: "flex-shrink-0 w-6 h-6",
                                name: "plus"
                            }))
                            : (_openBlock(), _createBlock(SvgIcon, {
                                key: 1,
                                class: "flex-shrink-0 w-6 h-6",
                                name: "minus"
                            }))
                    ], 2)
                ]),
                (__props.open)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _renderSlot(_ctx.$slots, "default")
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
